import { useEffect, useState } from "react";
import { useUpdateAppointment, useVacAppDetails } from "../api/app";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import showToast from "../../utils/toast";

const TherapyRecordingForm = () => {
      const [existingData, setExistingData] = useState(null);
  const [formData, setFormData] = useState({
    sessionNoDate: "",
    duration: "",
    participants: "",
    therapyMethod: "",
    objectives: { obj1: "", obj2: "", obj3: "" },
    selectedIssues: [],
    selectedTechniques: [],
    customIssue: "",
    customTechnique: "",
    observations: "",
    nextPlan: "",
    nextDate: "",
  });

  const updateAppData = useUpdateAppointment();
      const { id } = useParams();

      const navigate = useNavigate();
  const issuesList = [
    "Psychosocial stressors",
    "Interpersonal problems",
    "Intrapsychic conflicts",
    "Crisis situations",
    "Conduct difficulties",
    "Behavioural difficulties",
    "Emotional difficulties",
    "Developmental difficulties",
    "Adjustment issues",
    "Addictive behaviours",
    "Others",
  ];

  const suggestionsList = [
    "Psychoeducation",
    "CBT",
    "DBT",
    "ERP",
    "CDT",
    "MET",
    "RPT",
    "IPSRT",
    "Relaxation Training",
    "Mindfulness",
    "Family Therapy",
    "Psychotherapy and counselling",
    "Social skill training"
  ];

  const { data , refetch} = useVacAppDetails(id);
      const appointment = data?.appointment || null;

      const handleSubmit = (e) => {
          e.preventDefault();
  
          updateAppData.mutate({
              _id: appointment?._id,
             therapySession : formData,
          });
  
          
          showToast("form is submittted");
      };
  
       useEffect(() => {
              setExistingData(
                  appointment?.therapySession ? appointment?.therapySession : null
              );
            },[appointment , id])

            useEffect(() => {
                    refetch()
                    if (existingData) {
                        setFormData({ ...formData, ...existingData });
                    }
                }, [existingData]);
  // ✅ General input/text/textarea handler
  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // ✅ General checkbox handler (for array fields)
  const handleCheckboxChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].includes(value)
        ? prev[field].filter((item) => item !== value) // remove
        : [...prev[field], value], // add
    }));
  };

  return (
    <div style={{ width : '100%'}}>
    <div style={{ backgroundColor: "white", minHeight: "100vh", padding: "1rem" }}>
      <div style={{ maxWidth: "56rem", margin: "0 auto", border: "1px solid #d1d5db", borderRadius: "0.5rem", overflow: "hidden" }}>
        
        {/* ✅ Header */}
        <div style={{ textAlign: "center", fontSize: "1.125rem", fontWeight: "bold", padding: "0.5rem", borderBottom: "1px solid #d1d5db" }}>
          Therapy Session Recording Form
        </div>

        {/* ✅ Session Info */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ gridColumn: "span 2", padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>
            <label>Session No. & Date</label>
            <input
              type="text"
              value={formData.sessionNoDate}
              onChange={(e) => handleChange("sessionNoDate", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
            />
          </div>
          <div style={{ gridColumn: "span 1", padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>
            <label>Duration</label>
            <input
              type="text"
              value={formData.duration}
              onChange={(e) => handleChange("duration", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
            />
          </div>
        </div>

        {/* ✅ Participants */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Session Participants</div>
          <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.participants}
              onChange={(e) => handleChange("participants", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
            />
          </div>
        </div>

        {/* ✅ Therapy Method */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Therapy method</div>
          <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.therapyMethod}
              onChange={(e) => handleChange("therapyMethod", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
              placeholder="Individual/Family/Couple/Group"
            />
          </div>
        </div>

        {/* ✅ Objectives */}
        {["obj1", "obj2", "obj3"].map((obj, idx) => (
          <div key={obj} style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
            <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Objective-{idx + 1}</div>
            <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
              <input
                type="text"
                value={formData.objectives[obj]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    objectives: { ...prev.objectives, [obj]: e.target.value },
                  }))
                }
                style={{ width: "100%", border: "none", outline: "none" }}
              />
            </div>
          </div>
        ))}

        {/* ✅ Key Issues */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Key issues/themes discussed</div>
          <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.customIssue}
              onChange={(e) => handleChange("customIssue", e.target.value)}
              placeholder="Enter custom Issue"
              style={{ width: "100%", border: "none", outline: "none", marginBottom: "0.5rem" }}
            />
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {issuesList.map((issue) => (
                <label key={issue} style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
                  <input
                    type="checkbox"
                    checked={formData.selectedIssues.includes(issue)}
                    onChange={() => handleCheckboxChange("selectedIssues", issue)}
                  />
                  {issue}
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* ✅ Therapy Techniques */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Therapy techniques used</div>
          <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.customTechnique}
              onChange={(e) => handleChange("customTechnique", e.target.value)}
              placeholder="Enter custom technique"
              style={{ width: "100%", border: "none", outline: "none", marginBottom: "0.5rem" }}
            />
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              {suggestionsList.map((tech) => (
                <label key={tech} style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
                  <input
                    type="checkbox"
                    checked={formData.selectedTechniques.includes(tech)}
                    onChange={() => handleCheckboxChange("selectedTechniques", tech)}
                  />
                  {tech}
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* ✅ Observations */}
        <div style={{ borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", fontWeight: "bold" }}>Therapist observations and reflections</div>
          <div style={{ padding: "0.5rem" }}>
            <textarea
              value={formData.observations}
              onChange={(e) => handleChange("observations", e.target.value)}
              style={{ width: "100%", minHeight: "8rem", border: "none", outline: "none" }}
            />
          </div>
        </div>

        {/* ✅ Next Plan */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", borderBottom: "1px solid #d1d5db", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Plan for next session</div>
          <div style={{ gridColumn: "span 2", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.nextPlan}
              onChange={(e) => handleChange("nextPlan", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
            />
          </div>
        </div>

        {/* ✅ Next Date */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", fontSize: "0.875rem" }}>
          <div style={{ padding: "0.5rem", borderRight: "1px solid #d1d5db" }}>Date for next session</div>
          <div style={{ gridColumn: "span 3", padding: "0.5rem" }}>
            <input
              type="text"
              value={formData.nextDate}
              onChange={(e) => handleChange("nextDate", e.target.value)}
              style={{ width: "100%", border: "none", outline: "none" }}
            />
          </div>
        </div>
      </div>

      
                    
    </div>
   <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1rem" }}>
  <button
    onClick={handleSubmit}
    style={{
      padding: "10px 20px",
      backgroundColor: "#28a745",
      color: "#FFFFFF",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      maxWidth: "28rem",
      width: "100%",
      marginBottom : '15px'
    }}
  >
    Submit
  </button>
  <button
    onClick={() => navigate(`/therapyrecordingreport/${id}`)}
    style={{
      padding: "10px 20px",
      backgroundColor: "#007bff",
      color: "#FFFFFF",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      maxWidth: "28rem",
      width: "100%",
      marginBottom : '15px'
    }}
  >
    View/Print Report
  </button>
</div>
                    </div>
  );
};

export default TherapyRecordingForm;
